import { render, staticRenderFns } from "./PolicyFilter.vue?vue&type=template&id=6c0bfb8c"
import script from "./PolicyFilter.vue?vue&type=script&lang=ts"
export * from "./PolicyFilter.vue?vue&type=script&lang=ts"
import style0 from "./PolicyFilter.vue?vue&type=style&index=0&id=6c0bfb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports